import { CookieCategory, getBranch, isCookieConsentGiven } from './cookie';

const getReferrerDomain = () => {
  const domain = window.document.referrer.split('/')[2];
  if (!domain) {
    return '';
  }
  return domain.replace(/^www\./, '');
};

const getReferrerUrlPath = () => {
  const referrerValues = window.document.referrer.split('/');
  if (referrerValues.length <= 3) return '';
  return referrerValues.splice(3).join('/');
};

// Needs to trigger everytime we change route
export const setupGPT = ({ isActive, community, postId, tagArray, pageType = '' }) => {
  if (!isCookieConsentGiven(CookieCategory.Advertising)) return;

  googletag.cmd.push(() => {
    // set page-level key-value targeting
    googletag.pubads()
      .setTargeting('user', isActive ? 'member' : 'visitor')
      .setTargeting('branch', getBranch())
      .setTargeting('community', community)
      .setTargeting('post-id', postId.toString())
      .setTargeting('terms', tagArray)
      .setTargeting('source-domain', getReferrerDomain())
      .setTargeting('source-page', getReferrerUrlPath())
      .setTargeting('page-type', pageType);

    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs(true);
    googletag.enableServices(); // call all ad slots on the page in one call
  });
};
